import React from 'react';
import { Button as MuiButton, ButtonProps } from '@mui/material';
import { useButtonStyles } from './styles';
import { Spinner } from '../inputAutoComplete/styles';
import LoadingLockScreen from '../loadingLockScreen/loadingLockScreen';

interface IButtonProps extends ButtonProps {
  children: React.ReactNode;
  isLoading?: boolean;
  isLoadingLockScreen?: boolean;
}

function Button({ children, isLoading = false, isLoadingLockScreen, ...props }: IButtonProps) {
  const styles = useButtonStyles();

  return (
    <MuiButton
      className={styles.formButton}
      {...props}
      disabled={props.disabled || isLoading}
    >
      {children}
      {isLoading && <Spinner style={{ margin: '0 -10px 0 10px' }} />}
      {(isLoadingLockScreen && isLoading) && <LoadingLockScreen />}
    </MuiButton>
  );
}

export default Button;
